module.exports = __webpack_public_path__ + "ee20d3d41370a33de3826d24acf0a9bf.svg";